import { Component, OnInit } from "@angular/core";
import { Platform } from "@ionic/angular";
import { Plugins } from "@capacitor/core";
import { TranslateService } from "@ngx-translate/core";
const { Share } = Plugins;

@Component({
    selector: "app-card-invite",
    templateUrl: "./card-invite.component.html",
})
export class CardInviteComponent implements OnInit {
    constructor(private platform: Platform, private translate: TranslateService) {}

    ngOnInit() {}

    async onShare() {
        let url = "https://yeswecan-cer.org/";
        if (this.platform.is("ios")) {
            url = "https://apps.apple.com/de/app/yes-app/id1439189846";
        } else if (this.platform.is("android")) {
            url = "https://play.google.com/store/apps/details?id=org.yeswecancer.app";
        }

        await Share.share({
            title: this.translate.instant("Hol Dir die YES!APP"),
            text: this.translate.instant(
                `ich empfehle Dir Deutschlands größte Selbsthilfegruppe für Krebspatienten und Angehörige. ` +
                    `Hol Dir jetzt gratis im App Store und bei Google Play die YES!APP, in der Du Patienten mit Deiner Krankheit findest, mit denen Du dich austauschen kannst.`
            ),
            url,
            dialogTitle: this.translate.instant("Teilen"),
        });
    }
}
